// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"86475d17","195":"40c63b9c","237":"fec361ac","425":"b7f7bd53","624":"5e3a64a2","659":"75884732","803":"7ec710ab","826":"b8722b25","855":"a80a10c5"}[chunkId] + ".chunk.css";
};